import { render, staticRenderFns } from "./OrderLinks.vue?vue&type=template&id=490ef0a6&scoped=true"
import script from "./OrderLinks.vue?vue&type=script&lang=js"
export * from "./OrderLinks.vue?vue&type=script&lang=js"
import style0 from "./OrderLinks.vue?vue&type=style&index=0&id=490ef0a6&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490ef0a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardSubtitle,VCardText,VDivider,VIcon,VList})
